import { Badge } from '@/shared/ui/badge';
import { ReceivableStatus } from '../../utils/types';

type Props = {
  status: ReceivableStatus;
};

const STATUS_LABELS: Record<ReceivableStatus, string> = {
  WAITING: 'Aguardando',
  RECEIVED: 'Recebido',
  CONCLUDED: 'Concluído',
  CALCULATING: 'Calculando',
  CALCULATED: 'Calculado',
  FAIL: 'Falhou',
};

const STATUS_VARIANT: Record<ReceivableStatus, 'default' | 'secondary' | 'success' | 'destructive'> = {
  WAITING: 'secondary',
  RECEIVED: 'secondary',
  CONCLUDED: 'success',
  CALCULATING: 'secondary',
  CALCULATED: 'success',
  FAIL: 'destructive',
};

export function ReceivableStatusBadge({ status }: Props) {
  return (
    <Badge variant={STATUS_VARIANT[status] || 'default'}>
      {STATUS_LABELS[status] || status}
    </Badge>
  );
}
